// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"6e292398","438":"f4e9d976","558":"077bade8","670":"567bdf54","835":"5bbe0152","954":"648fc79d"}[chunkId] + ".chunk.js";
};